export const insertRightPermissionsOnSelectedRole = {
  async insertRightPermissionsOnSelectedRole() {
    // Selects
    await this.setSelectedRamaisRelatoriosPABX(
      this.getSpecificRole.ramaisRelatoriosPabxPermitidos_ids
    );
    await this.setSelectedRamaisMonitorRamais(
      this.getSpecificRole.ramaisMonitorRamaisPermitidos_ids
    );
    await this.setSelectedTagsRelatoriosPABX(
      this.getSpecificRole.tagsRelatorioPabxPermitidos_ids
    );
    await this.setSelectedTagsPesquisaSatisfacao(
      this.getSpecificRole.tagsPesquisaPermitidos_ids
    );
    await this.setSelectedConferencias(
      this.getSpecificRole.conferenciasPermitidos_ids
    );
    await this.setSelectedFilas(this.getSpecificRole.queuesPermitidos_ids);
    await this.setSelectedDepartamentos(this.getSpecificRole.departamentosPermitidos_ids);
    await this.setSelectedOperadores(
      this.getSpecificRole.agentesPermitidos_ids
    );
    await this.setSelectedPesquisasSatisfacao(
      this.getSpecificRole.pesquisasPermitidos_ids
    );
    await this.setSelectedRoles(this.getSpecificRole.rolesPermitidos_ids);

    const permitions = this.getSpecificRole.permissions.map(
      (permission) => permission.id
    );
    this.changeAllPermissionsID(permitions);
  },
};
